import {SeedDataConfig} from 'analysis-tool/create-analysis-modal/SeedDataTypes';
import {AnalyticsEventMetadata} from 'analytics/AnalyticsTypes';
import * as net from 'util/Net';
import {OngoingTaskResponse} from 'util/TaskRunner';
import {JSONValue} from 'util/Types';

export interface CreateAnalysisParams {
  folderId: string;
  name: string;
  seedDataConfig?: SeedDataConfig;
  studyIds?: Array<string>;
  templateRun?: {
    templateId: string;
    variableBindings?: Array<{variableId: string; variableValue: JSONValue}>;
  };
}

export interface CreateAnalysisResponse {
  analysisId: string;
  seedAnalysisTask?: OngoingTaskResponse | null;
}

export function createAnalysis(
  data: CreateAnalysisParams,
  analyticsMetadata?: AnalyticsEventMetadata
): Promise<CreateAnalysisResponse> {
  return net.postJSONPromise({url: '/1/api/analyses', data, analyticsMetadata});
}

export interface UpdateAnalysisParentParams {
  folderId?: string;
}
export type UpdateAnalysisParams = {
  name?: string;
  description?: string | null;
} & UpdateAnalysisParentParams;

export interface UpdateAnalysisResponse {
  analysisId: string;
}

export function updateAnalysis(
  analysisId: string,
  data: UpdateAnalysisParams
): Promise<UpdateAnalysisResponse> {
  return net.patchJSONPromise({
    url: `/1/api/analyses/${analysisId}`,
    data,
  });
}

export interface CloneAnalysisParams {
  folderId: string;
  name: string;
  description: string | null;
}

export interface CloneAnalysisResponse {
  newAnalysisId: string;
}

export function cloneAnalysis(
  analysisId: string,
  data: CloneAnalysisParams,
  analyticsMetadata?: AnalyticsEventMetadata
): Promise<CloneAnalysisResponse> {
  return net.postJSONPromise({url: `/1/api/analyses/${analysisId}:clone`, data, analyticsMetadata});
}
